"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../shared/tokens/tokens"));
var _Icon = require("../media/icon/Icon");
var _icon = require("../media/icon/icon.tokens");
var _jsxRuntime = require("react/jsx-runtime");
var PillWrapper = _styledComponents.default.div.withConfig({
  displayName: "Pill__PillWrapper",
  componentId: "sc-1s9gr0g-0"
})(["display:inline-flex;align-items:center;justify-content:center;gap:", ";background-color:", ";padding:", " ", ";border-radius:", ";"], _tokens.default.sky.sys.spacing[100], _tokens.default.sky.sys.color.background.accent[1], _tokens.default.sky.sys.spacing[100], _tokens.default.sky.sys.spacing[200], _tokens.default.sky.sys.size.borderradius[5]);
var PillText = _styledComponents.default.div.withConfig({
  displayName: "Pill__PillText",
  componentId: "sc-1s9gr0g-1"
})(["", ";color:", ";"], _tokens.default.sky.sys.font.subheading['2'], _tokens.default.sky.sys.color.text.content.main);
var Pill = function Pill(_ref) {
  var icon = _ref.icon,
    children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(PillWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        icon: icon,
        size: _icon.IconSize.m,
        viewBox: '0 0 20 20'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PillText, {
        children: children
      })]
    })
  });
};
var _default = exports.default = Pill;